module.exports = __webpack_public_path__ + "img/article-24px.ca6ba12c.svg";